import { theme } from 'Assets/Styles/theme'

export default ({ props }) => {
  return {
    row: {
      display: 'flex',
      '&:nth-child(odd) > div:nth-child(2)': { background: '#eee' },
    },
    tableRow: {
      display: 'flex',
      justifyContent: 'space-between',
      flexGrow: 1,
      border: '1px solid #ccc',
      '&:not(:last-child)': {
        borderBottom: 0,
      },
    },
    index: {
      width: '40px',
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    tableCell: {
      padding: '8px',
      minWidth: '25px',
    },
    checkboxBlock: {
      width: '10%',
      maxWidth: 25,
    },
    code: {
      width: '30%',
    },
    city: {
      width: '30%',
    },
    qrCodeColumn: {
      width: '30%',
      display: 'flex',
      alignItems: 'center',
      padding: '0 8px',
    },
    table: {
      marginTop: '10px',
      marginLeft: '-40px',
    },
    qrCodeIcon: {
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
    },
    button: {
      textTransform: 'none',
      backgroundColor: '#fff',
      '&:not(:last-child)': {
        marginRight: '8px',
      },
    },
    highlight: { color: theme.colors.red },
  }
}
